<template>
  <div id="Accounts">
    <loading v-if="loadingRender"></loading>
    <panel
      class="no-print"
      Title="لیست حساب ها"
      Des="از طریق این فرم می توانید لیست حساب های خود را مشاهده کنید و عملیات های گردش و واریز وجه انجام  دهید"
      :IsBtnBack="true"
      ClassCustom="bg-dark-Custom text-right mt-2"
    ></panel>

    <div class="row text-right no-print">
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <div class="btn-group btn-group-toggle" data-toggle="buttons">
              <label class="btn btn-dark active border-none" style="cursor: pointer">
                <input @click="ShowCard(true)" type="radio" name="options" id="option1" autocomplete="off" />
                <i class="fas fa-columns"></i> ستونی
              </label>
              <label class="btn btn-dark border-none" style="cursor: pointer">
                <input @click="ShowCard(false)" type="radio" name="options" id="option2" autocomplete="off" checked /><i class="fas fa-list-alt"></i> ردیفی
              </label>
            </div>
            <ul class="nav nav-tabs mt-3 card-header-tabs" id="myTab" role="tablist" dir="rtl">
              <li class="nav-item">
                <a class="nav-link active text-dark" id="Detail-tab" data-toggle="tab" href="#Detailtab" role="tab" aria-controls="Detailtab" aria-selected="true">حساب های خودم</a>
              </li>
              <li class="nav-item">
                <a class="nav-link text-dark" id="Logo-tab" data-toggle="tab" href="#Logotab" role="tab" aria-controls="Settingtab" aria-selected="true">حساب های وابسته</a>
              </li>
            </ul>
          </div>
          <div class="card-body">
            <div class="tab-content text-right p-3" id="Controler">
              <div class="tab-pane fade show active" id="Detailtab" role="tabpanel" aria-labelledby="Detail-tab">
                <div class="container mt-3 mb-3">
                  <div class="row">
                    <div class="col-md-2 col-12">
                      <div class="dropdown">
                        <button class="btn btn-dark border border-dark rounded dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-expanded="false">
                          <i class="fas fa-filter"></i> فیلتر حساب ها
                        </button>
                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                          <a
                            class="dropdown-item"
                            href="Javascript:;"
                            @click="
                              GetItemCard(false);
                              $ResetTimer();
                            "
                            >حساب های دارای مانده
                            <i v-if="selectedBedehi && selectedAllBedehi == false" class="fas fa-check text-success"></i>
                          </a>
                          <a
                            class="dropdown-item"
                            href="Javascript:;"
                            @click="
                              GetItemCard(true);
                              $ResetTimer();
                            "
                            >همه حساب ها
                            <i v-if="selectedAllBedehi && selectedBedehi == false" class="fas fa-check text-success"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="CardItem && CardItem.length > 0 && IsShowCard == true" class="row">
                    <div class="col-md-4 h-100" style="height: 100% !important" v-for="(item, index) in CardItem" :key="index">
                      <div class="card Netpa-Shadow border-0 mb-3 costom-card" dir="rtl">
                        <div class="row border-bottom">
                          <div class="text-right col-12">
                            <router-link
                              v-if="item.isTurnover"
                              title="گردش حساب"
                              :to="{
                                name: 'Turnover',
                                params: {
                                  TaahodatId: item.id,
                                  wwwtblAzaIdAccount: item.wwwtblAzaId,
                                  wwwtblSarfaslTypeId: 2,
                                },
                              }"
                              ><span class="fas fa-list text-warning" style="font-size: 16px"></span
                            ></router-link>
                            <a v-if="$session.get('CustCode') != 868" data-toggle="modal" data-target="#Modal-Mobile" @click="OpenDetail(index)" title="جزئیات حساب"
                              ><span class="fas mx-2 fa-info-circle text-primary Pointer" style="font-size: 15px"></span
                            ></a>
                            <a
                              v-else
                              data-toggle="modal"
                              data-target="#Modal-Mobile"
                              @click="OpenDetail(index)"
                              title="جزئیات حساب"
                              class="Pointer mr-2 badge badge-info text-light font-weight-normal px-2 py-1"
                              >جزئیات حساب</a
                            >
                            <!-- <i v-if="$session.get('CustCode') == 8002 ||$session.get('CustCode') == 866" class="fa fa-qrcode fa-2x float-left Pointer text-secondary" title="ایجاد لینک پرداخت" @click="openGeneratorQR(item)"></i> -->
                            <i v-if="$session.get('CustCode') == 866" class="fa fa-qrcode fa-2x float-left Pointer text-secondary" title="ایجاد لینک پرداخت" @click="openGeneratorQR(item)"></i>
                            <hr />
                          </div>
                          <div class="col-lg-7 col-md-12 col-12 text-right">
                            <div class="row">
                              <div class="col-xl-6 col-12 mb-2">
                                <label for="lblNoeHesab" class="text-right font-weight-bold no-wrap"> نوع حساب : </label>
                              </div>
                              <div class="col-xl-6 col-12 mb-2">
                                <span class="text-right font-weight-bold text-dark fl"> {{ item.desNoe }} </span>
                              </div>
                              <div class="col-xl-6 col-12 mb-2">
                                <label for="lblVcode" class="text-right font-weight-bold no-wrap"> شماره حساب : </label>
                              </div>
                              <div class="col-xl-6 col-12 mb-2">
                                <span dir="rtl" class="text-right font-weight-bold no-wrap text-dark fl">
                                  {{ item.vCode }}
                                </span>
                              </div>
                              <div class="col-xl-6 col-12 mb-2">
                                <label for="lblDate" class="text-right font-weight-bold no-wrap"> افتتاح حساب : </label>
                              </div>
                              <div class="col-xl-6 col-12 mb-2">
                                <span class="text-right font-weight-bold no-wrap text-dark fl">{{ item.tarix }} </span>
                              </div>
                              <div class="col-xl-6 col-12 mb-2">
                                <label for="lblMabSharj" class="text-right font-weight-bold no-wrap"> شناسه واریز : </label>
                              </div>
                              <div class="col-xl-6 col-12 mb-2">
                                <span class="text-right font-weight-bold no-wrap text-dark fl">{{ item.shenaseVariz }} </span>
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-5 col-md-12 col-12 text-center">
                            <div class="row text-right">
                              <div class="col-12">
                                <label for="lblMojodi" class="text-right font-weight-bold no-wrap"> موجودی : </label>
                              </div>
                              <div class="col-12">
                                <span class="text-right font-weight-bold no-wrap text-dark fl"
                                  >{{ $Comma3ragham(Number(item.mande.replaceAll(",", "")) + Number(item.sumMabTaeedNaShode.replaceAll(",", ""))) }}
                                </span>
                              </div>
                            </div>
                            <hr />
                            <div class="row text-right mb-2" v-if="$session.get('CustCode') != 868">
                              <div class="col-12">
                                <label for="lblGhabelBardasht" class="text-right font-weight-bold no-wrap"> قابل برداشت : </label>
                              </div>
                              <div class="col-12">
                                <span class="text-right font-weight-bold no-wrap text-dark fl">
                                  {{ $Comma3ragham(Number(item.ghabelBardasht.replaceAll(",", ""))) }}
                                </span>
                              </div>
                            </div>
  
                          </div>
                          <!-- <div v-if="$session.get('CustCode')==868">************{{ item }}</div> -->
                          <div class="col-12"></div>
                          <div class="col-12 text-center" v-if="item.spName != null && item.spName != ''">
                            <hr />
                            {{ GetAtach(item) }}

                            <div class="" v-if="item.showScore">
                              <label>
                                <!-- امتیاز شما [ <b class="text-danger">{{ item.emtiazXas }}</b> ] می باشد -->
                                <div class="" v-if="item.showMessageZeroScore == true">
                                  امتیاز شما [ <b class="text-danger">{{ GetSumEmtiaz() }}</b> ] و رتبه بندی شما [ <b class="text-danger">{{ item.rankNumber }}</b> ] می باشد
                                </div>
                                <div v-if="item.showMessageZeroScore == true && item.rankNumber == 0" class="d-block text-warning">{{ item.messageZeroScore }}</div>
                                <small
                                  class="badge badge-secondary text-light font-weight-normal px-3 mr-2 Pointer"
                                  id="ZamenModal"
                                  data-toggle="modal"
                                  data-target="#Modal-light"
                                  @click="
                                    GetAtach(item);
                                    AtachVam = true;
                                  "
                                  >جزئیــات امتیازات</small
                                ></label
                              >
                            </div>
                            <!-- <div class="">
                              <label v-if="item.showMessageZeroScore == true && item.rankNumber != 0"> شما نفر [ </label><span v-if="item.rankNumber != 0" class="font-weight-bold text-danger"> {{ item.rankNumber }} </span><label v-if="item.rankNumber != 0"> ] بر حسب امتیاز مکتسبه می باشید</label>
                              <div v-if="item.showMessageZeroScore == true && item.rankNumber == 0" class="d-block text-warning">{{ item.messageZeroScore }}</div>
                            </div> -->
                          </div>
                          <div class="col-12 text-center my-2" v-if="CheckIsSaham(item) == true">
                            <hr />
                            <span v-if="item.showScore"
                              >امتیاز وام تعاونی شما :[ <span class="text-danger font-weight-bold">{{ item.emtiazXas2 == null ? 0 : item.emtiazXas2 }}</span> ]</span
                            >
                            <div class="">
                              <label v-if="item.showMessageZeroScore == true && item.rankNumber2 != 0 && item.rankNumber2 != null"> شما نفر [ </label
                              ><span v-if="item.rankNumber2 != 0 && item.rankNumber2 != null" class="font-weight-bold text-danger"> {{ item.rankNumber2 == null ? 0 : item.rankNumber2 }} </span
                              ><label v-if="item.showMessageZeroScore == true && item.rankNumber2 != 0 && item.rankNumber2 != null"> ] بر حسب امتیاز مکتسبه می باشید</label>
                              <div v-if="item.showMessageZeroScore == true && (item.rankNumber2 == 0 || item.rankNumber2 == null)" class="d-block text-warning">{{ item.messageZeroScore }}</div>
                            </div>
                            <span class="Pointer btn btn-outline-dark custom-class NetPa-btn mb-1 w-100 no-wrap mt-2" @click="ShowBargeSaham(item)">نمایش برگه سهام</span>
                          </div>
                        </div>
                        <div class="row mt-2">
                          <div class="col-xl-4 col-12" v-if="$session.get('AccessMenu').filter((x) => x.id == 7)[0].isMenu && item.isPayment && item.tblSarfaslTypeId != 6">
                            <a type="button" class="btn btn-outline-success custom-class NetPa-btn mb-1 w-100 no-wrap Pointer" @click="Deposit(item)" style="font-size: 0.79rem !important">{{
                              $session.get("IsTaavoniEtebar") == true ? "افزایش اعتبار" : "واریز"
                            }}</a>
                          </div>
                          <div class="col-xl-4 col-12">
                            <button
                              v-if="$session.get('AccessMenu').filter((x) => x.id == 13)[0].isMenu && item.isDebtor == true"
                              type="button"
                              class="btn btn-outline-danger custom-class NetPa-btn mb-1 w-100 no-wrap"
                              :disabled="item.ghabelBardasht <= 0"
                              :class="item.ghabelBardasht <= 0 ? 'btn-secondary text-dark disabled' : ''"
                              @click="debtor(item)"
                              style="font-size: 0.79rem !important"
                            >
                              برداشت
                            </button>
                            <button type="button" class="d-none" id="debtor" data-toggle="modal" data-target="#Modal-light"></button>
                          </div>
                          <div class="col-xl-4 col-12">
                            <router-link
                              v-if="item.isTurnover == true"
                              title="گردش حساب"
                              :to="{
                                name: 'Turnover',
                                params: {
                                  TaahodatId: item.id,
                                  wwwtblAzaIdAccount: item.wwwtblAzaId,
                                  wwwtblSarfaslTypeId: 2,
                                },
                              }"
                              class="btn btn-outline-dark custom-class NetPa-btn mb-1 w-100 no-wrap"
                              style="font-size: 0.79rem !important"
                              >گردش
                            </router-link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row mt-2">
                    <div class="col-12">
                      <vue-bootstrap4-table v-if="IsShowCard == false" :rows="rows" :columns="columns" :config="config" :classes="classes">
                        <template slot="sort-asc-icon">
                          <i class="fa fa-sort-up"></i>
                        </template>
                        <template slot="sort-desc-icon">
                          <i class="fa fa-sort-down"></i>
                        </template>
                        <template slot="no-sort-icon">
                          <i class="fa fa-sort"></i>
                        </template>
                        <template slot="Emtiaz" slot-scope="props" v-if="props.row.spName != null && props.row.spName != ''">
                          <!-- {{ props.row.emtiazXas }} -->
                          {{ GetSumEmtiaz() }}
                        </template>
                        <template slot="Detail" slot-scope="props">
                          <a data-toggle="modal" data-target="#Modal-Mobile" @click="OpenDetail(props.row.vbt_id - 1)" class="btn btn-success custom-class NetPa-btn mb-1 w-100 no-wrap Pointer"
                            >جزئیــات بیشتر</a
                          >
                        </template>
                        <template slot="action-slot" slot-scope="props">
                          <div class="row">
                            <div class="col-xl-4 col-12" v-if="props.row.isPayment">
                              <a
                                v-if="$session.get('AccessMenu').filter((x) => x.id == 11)[0].isMenu"
                                @click="Deposit(props.row)"
                                class="btn btn-outline-success custom-class NetPa-btn mb-1 w-100 no-wrap Pointer"
                                >پرداخت</a
                              >
                            </div>
                            <div class="col-xl-4 col-12">
                              <router-link
                                v-if="props.row.isTurnover == true"
                                title="گردش"
                                :to="{
                                  name: 'Turnover',
                                  params: {
                                    TaahodatId: props.row.id,
                                    wwwtblAzaIdAccount: props.row.wwwtblAzaId,
                                    wwwtblSarfaslTypeId: 2,
                                  },
                                }"
                                class="btn btn-outline-dark custom-class NetPa-btn mb-1 w-100 no-wrap"
                              >
                                گردش
                              </router-link>
                            </div>
                            <div class="col-xl-4 col-12">
                              <button
                                v-if="$session.get('AccessMenu').filter((x) => x.id == 13)[0].isMenu && props.row.isDebtor == true"
                                type="button"
                                class="btn btn-outline-danger custom-class NetPa-btn mb-1 w-100 no-wrap"
                                :disabled="props.row.ghabelBardasht <= 0"
                                :class="props.row.ghabelBardasht <= 0 ? 'btn-secondary text-dark disabled' : ''"
                                @click="debtor(props.row.id)"
                                style="font-size: 0.79rem !important"
                              >
                                برداشت
                              </button>
                              <button type="button" class="d-none" id="debtor" data-toggle="modal" data-target="#Modal-light"></button>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-xl-12 col-12" v-if="CheckIsSaham(props.row) == true">
                              امتیاز وام تعاونی شما :[ <span class="text-danger">{{ props.row.emtiazXas2 == null ? 0 : props.row.emtiazXas2 }}</span> ]
                              <span class="Pointer btn btn-outline-dark custom-class NetPa-btn mb-1 w-100 no-wrap" @click="ShowBargeSaham(props.row)">نمایش برگه سهام</span>
                            </div>
                            <div class="col-xl-12 col-12" v-if="props.row.spName != null && props.row.spName != ''">
                              <span class="Pointer btn btn-outline-dark custom-class NetPa-btn mb-1 w-100 no-wrap" data-toggle="modal" data-target="#Modal-light" @click="GetAtach(props.row)"
                                >جزئیات امتیازات</span
                              >
                            </div>
                          </div>
                        </template>

                        <template slot="empty-results">
                          <p class="text-right">اطلاعاتی یافت نشد</p>
                        </template>
                      </vue-bootstrap4-table>
                    </div>
                  </div>
                </div>
              </div>
              <div class="tab-pane fade show" id="Logotab" role="tabpanel" aria-labelledby="Detail-tab">
                <div class="container mt-3 mb-3">
                  <div v-if="CardItemTaahodatSahebHesab.length > 0" class="row">
                    <div class="col-md-2 col-12">
                      <div class="dropdown">
                        <button class="btn btn-dark border border-dark rounded dropdown-toggle" type="button" id="dropdownMenuButton2" data-toggle="dropdown" aria-expanded="false">
                          <i class="fas fa-filter"></i>حساب های وابسته
                        </button>
                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton2">
                          <a
                            class="dropdown-item"
                            href="javascript:;"
                            v-for="item in groupBy"
                            :key="item.Id"
                            :id="item.wwwtblAzaId"
                            @click="
                              GetSahebHesab(item.wwwtblAzaId, false);
                              $ResetTimer();
                            "
                          >
                            {{ item.nameFamily }}</a
                          >
                          <hr />
                          <a
                            class="dropdown-item"
                            href="Javascript:;"
                            @click="
                              GetSahebHesab(0, true);
                              $ResetTimer();
                            "
                            >همه حساب های وابسته
                            <i class="fas fa-check text-success"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-else class="row">
                    <div class="col-12">
                      <div class="alert alert-warning w-100 text-center">در حال حاضر حساب های وابسته شما صفر میباشد</div>
                    </div>
                  </div>
                  <div v-if="FilterCardItemTaahodatSahebHesab && FilterCardItemTaahodatSahebHesab.length > 0 && IsTaahodatSahebHesab == true && IsShowCard == true" class="row">
                    <div class="col-md-4" v-for="(item, index) in FilterCardItemTaahodatSahebHesab" :key="index">
                      <div class="card border-0 mb-3 costom-card-sahebanhesab" dir="rtl">
                        <div class="row border-bottom">
                          <div class="text-right col-12">
                            <router-link
                              v-if="item.isTurnover == true"
                              title="گردش حساب"
                              :to="{
                                name: 'Turnover',
                                params: {
                                  TaahodatId: item.id,
                                  wwwtblSarfaslTypeId: 2,
                                },
                              }"
                              ><span class="fas fa-list text-warning" style="font-size: 16px"></span
                            ></router-link>

                            <a data-toggle="modal" data-target="#Modal-Mobile" @click="OpenDetailSahebanHesab(index)" title="جزئیات حساب"
                              ><i class="fas mx-2 fa-info-circle text-primary Pointer" style="font-size: 15px"></i
                            ></a>
                            <small class="text-dark float-left ml-3"
                              ><span class="fas fa-user text-success" style="font-size: 15px"></span>
                              {{ item.nameFamily }}
                            </small>
                            <hr />
                          </div>
                          <div class="col-lg-7 col-md-12 col-12 text-right">
                            <div class="row">
                              <div class="col-xl-6 col-12 mb-2">
                                <label for="lblNoeHesab" class="text-right font-weight-bold no-wrap"> نوع حساب : </label>
                              </div>
                              <div class="col-xl-6 col-12 mb-2">
                                <span class="text-right font-weight-bold no-wrap text-dark fl">
                                  {{ item.desNoe }}
                                </span>
                              </div>
                              <div class="col-xl-6 col-12 mb-2">
                                <label for="lblVcode" class="text-right font-weight-bold no-wrap"> شماره حساب : </label>
                              </div>
                              <div class="col-xl-6 col-12 mb-2">
                                <span dir="rtl" class="text-right font-weight-bold no-wrap text-dark fl">
                                  {{ item.vCode }}
                                </span>
                              </div>
                              <div class="col-xl-6 col-12 mb-2">
                                <label for="lblDate" class="text-right font-weight-bold no-wrap"> افتتاح حساب : </label>
                              </div>
                              <div class="col-xl-6 col-12 mb-2">
                                <span class="text-right font-weight-bold no-wrap text-dark fl">{{ item.tarix }} </span>
                              </div>
                              <div class="col-xl-6 col-12 mb-2">
                                <label for="lblMabSharj" class="text-right font-weight-bold no-wrap"> شناسه واریز : </label>
                              </div>
                              <div class="col-xl-6 col-12 mb-2">
                                <span class="text-right font-weight-bold no-wrap text-dark fl">{{ item.shenaseVariz }} </span>
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-5 col-md-12 col-12 text-center">
                            <div class="">
                              <p class="text-center m-0">موجودی</p>
                              <small class="card-text">{{ $Comma3ragham(Number(item.mande.replaceAll(",", "")) + Number(item.sumMabTaeedNaShode.replaceAll(",", ""))) }}</small>
                              <hr />
                              <p class="text-center m-0">قابل برداشت</p>
                              <small class="card-text">{{ $Comma3ragham(Number(item.ghabelBardasht.replaceAll(",", ""))) }}</small>
                              <hr />
                            </div>
                          </div>
                        </div>
                        <div class="row mt-2">
                          <div class="col-md-4 col-12" v-if="$session.get('AccessMenu').filter((x) => x.id == 7)[0].isMenu && item.isPayment && item.tblSarfaslTypeId != 6">
                            <a type="button" class="btn btn-outline-success custom-class NetPa-btn mb-1 w-100 no-wrap Pointer" @click="Deposit(item)" style="font-size: 0.79rem !important">{{
                              $session.get("IsTaavoniEtebar") == true ? "افزایش اعتبار" : "واریز"
                            }}</a>
                          </div>
                          <div class="col-md-4 col-12">
                            <button
                              v-if="$session.get('AccessMenu').filter((x) => x.id == 13)[0].isMenu && item.isDebtor == true"
                              type="button"
                              class="btn btn-outline-danger custom-class NetPa-btn mb-1 w-100 no-wrap"
                              :disabled="item.ghabelBardasht <= 0"
                              :class="item.ghabelBardasht <= 0 ? 'btn-secondary text-dark disabled' : ''"
                              @click="debtor(item)"
                              style="font-size: 0.79rem !important"
                            >
                              برداشت
                            </button>
                            <button type="button" class="d-none" id="debtor" data-toggle="modal" data-target="#Modal-light"></button>
                          </div>
                          <div class="col-md-4 col-12">
                            <router-link
                              v-if="item.isTurnover == true"
                              title="گردش حساب"
                              :to="{
                                name: 'Turnover',
                                params: {
                                  TaahodatId: item.id,
                                  wwwtblSarfaslTypeId: 2,
                                  wwwtblAzaIdAccount: item.wwwtblAzaId,
                                },
                              }"
                              class="btn btn-outline-dark custom-class NetPa-btn mb-1 w-100 no-wrap"
                              style="font-size: 0.79rem !important"
                              >گردش
                            </router-link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row mt-2">
                    <div class="col-12">
                      <vue-bootstrap4-table v-if="IsShowCard == false" :rows="rows2" :columns="columns2" :config="config" :classes="classes">
                        <template slot="sort-asc-icon">
                          <i class="fa fa-sort-up"></i>
                        </template>
                        <template slot="sort-desc-icon">
                          <i class="fa fa-sort-down"></i>
                        </template>
                        <template slot="no-sort-icon">
                          <i class="fa fa-sort"></i>
                        </template>
                        <template slot="action-slot" slot-scope="props">
                          <div class="row">
                            <div class="col-xl-4 col-12" v-if="props.row.isPayment">
                              <a
                                v-if="$session.get('AccessMenu').filter((x) => x.id == 11)[0].isMenu"
                                @click="Deposit(props.row)"
                                class="btn btn-outline-success custom-class NetPa-btn mb-1 w-100 no-wrap Pointer"
                                >پرداخت</a
                              >
                            </div>
                            <div class="col-xl-4 col-12">
                              <router-link
                                v-if="props.row.isTurnover == true"
                                title="گردش"
                                :to="{
                                  name: 'Turnover',
                                  params: {
                                    TaahodatId: props.row.id,
                                    wwwtblAzaIdAccount: props.row.wwwtblAzaId,
                                    wwwtblSarfaslTypeId: 2,
                                  },
                                }"
                                class="btn btn-outline-dark custom-class NetPa-btn mb-1 w-100 no-wrap"
                              >
                                گردش
                              </router-link>
                            </div>
                            <div class="col-xl-4 col-12">
                              <button
                                v-if="$session.get('AccessMenu').filter((x) => x.id == 13)[0].isMenu && props.row.isDebtor == true"
                                type="button"
                                class="btn btn-outline-danger custom-class NetPa-btn mb-1 w-100 no-wrap"
                                :disabled="props.row.ghabelBardasht <= 0"
                                :class="props.row.ghabelBardasht <= 0 ? 'btn-secondary text-dark disabled' : ''"
                                @click="debtor(props.row.id)"
                                style="font-size: 0.79rem !important"
                              >
                                برداشت
                              </button>
                              <button type="button" class="d-none" id="debtor" data-toggle="modal" data-target="#Modal-light"></button>
                            </div>
                          </div>
                        </template>
                        <template slot="empty-results">
                          <p class="text-right">اطلاعاتی یافت نشد</p>
                        </template>
                      </vue-bootstrap4-table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <modal-custom>
      <template v-slot:ContentModalLight>
        <!-- <debtor v-if="AtachVam==false && $store.state.renderComponent" :TaahodatId="taahodatId"></debtor> -->
        <div class="container-fluid text-center" dir="rtl">
          <div class="row">
            <div class="col-12 alert bg-dark text-light" style="font-size: 15px !important">جدول امتیازات وام شما به صورت زیر می باشد</div>
            <table class="table">
              <thead>
                <tr>
                  <th scope="col" style="width: 60% !important">عنوان</th>
                  <th scope="col" style="width: 20% !important">امتیاز</th>
                  <th scope="col" style="width: 20% !important">امتیاز مکتسبه</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in GridDataAtachVam" :key="index" :class="item.Base == null ? 'bg-gray' : ''">
                  <td>{{ item.Onvan }}</td>
                  <td>{{ item.Base != null ? item.Base : "" }}</td>
                  <td :class="item.Emtiaz > 0 && item.Emtiaz != null ? 'font-weight-bold' : ''">{{ item.Base != null ? item.Emtiaz : "" }}</td>
                </tr>
                <tr>
                  <td colspan="2" class="bg-dark text-light" style="width: 80% !important">جمع امتیازات</td>
                  <td class="font-weight-bold text-danger" style="width: 20% !important">{{ CalcEmtiazXasForTable(GridDataAtachVam) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </template>
      <template v-slot:HeaderModalInfo>
        <span>
          <i class="fas fa-info-circle text-dark mx-2" style="font-size: 16 !important"></i>
          <span style="font-size: 16 !important" class="text-light font-weight-bold">جزئیات حساب</span></span
        >
      </template>
      <template v-slot:ContentModalMobile>
        <div class="container-fluid">
          {{ CardItem[detailInModal] }}
          <div v-if="detailInModal != null" class="row p-3 rounded" style="background: #343a40">
            <div class="col-12 text-right">
              <h6 class="font-weight-bold text-right" style="font-size: 14px">
                <i class="fas fa-money-check ml-2" style="font-size: 14px"></i>
                {{ CardItem[detailInModal].desNoe }}
              </h6>
            </div>
            <!-- <div class="col-md-6 col-12 mt-1 text-right mt-2" style="font-size:15px !important"><i class="fas fa-square ml-2 text-success"></i> نوع حساب: <span class="text-dark" style="font-size:15px !important"> {{CardItem[detailInModal].desNoe}}</span></div> -->
            <div class="col-md-6 col-12 mt-1 text-right mt-2" style="font-size: 15px !important">
              <i class="fas fa-square ml-2 text-success"></i>شماره حساب:
              <span class="text-light" dir="rtl" style="font-size: 15px !important"> {{ CardItem[detailInModal].vCode }}</span>
            </div>
            <div class="col-md-6 col-12 mt-1 text-right mt-2" style="font-size: 15px !important">
              <i class="fas fa-square ml-2 text-success"></i>مانده:
              <span class="text-light" dir="rtl" style="font-size: 15px !important"> {{ $Comma3ragham(CardItem[detailInModal].mande) }}</span>
            </div>
            <div class="col-md-6 col-12 mt-1 text-right mt-2" style="font-size: 15px !important">
              <i class="fas fa-square ml-2 text-success"></i>تاریخ افتتاح حساب:
              <span class="text-light" dir="rtl" style="font-size: 15px !important"> {{ CardItem[detailInModal].tarix }}</span>
            </div>
            <div class="col-md-6 col-12 mt-1 text-right mt-2" style="font-size: 15px !important">
              <i class="fas fa-square ml-2 text-success"></i>تاریخ شروع شارژ:
              <span class="text-light" dir="rtl" style="font-size: 15px !important"> {{ CardItem[detailInModal].tarixShoroAghsat }}</span>
            </div>

            <div class="col-1 my-2"></div>
            <div class="col-10 border border-bottom my-2"></div>
            <div class="my-2"></div>
            <div class="col-12 text-right mt-2">
              <h6 class="font-weight-bold text-right" style="font-size: 14px"><i class="fas fa-ban ml-2" style="font-size: 14px"></i> مسدودی ها</h6>
            </div>
            <div class="col-md-6 col-12 mt-1 text-right mt-2" style="font-size: 15px !important">
              <i class="fas fa-square ml-2 text-warning"></i>مسدودی:
              <span class="text-light" style="font-size: 15px !important"> {{ $Comma3ragham(CardItem[detailInModal].mablaghSood) }}</span>
            </div>
            <div class="col-md-6 col-12 mt-1 text-right mt-2" style="font-size: 15px !important">
              <i class="fas fa-square ml-2 text-warning"></i> مسدودي بابت دريافت تسهيلات:
              <span class="text-light" style="font-size: 15px !important"> {{ $Comma3ragham(CardItem[detailInModal].mablaghMasdodBabateDarTashilat) }}</span>
            </div>
            <div class="col-md-6 col-12 mt-1 text-right mt-2" style="font-size: 15px !important">
              <i class="fas fa-square ml-2 text-warning"></i>مسدودي بابت معرفی:
              <span class="text-light" style="font-size: 15px !important"> {{ $Comma3ragham(CardItem[detailInModal].mablaghMasdodBabateMoarefi) }}</span>
            </div>
            <div class="col-md-6 col-12 mt-1 text-right mt-2"></div>

            <div class="col-1 my-2"></div>
            <div class="col-10 border border-bottom my-2"></div>
            <div class="my-2"></div>
            <div class="row text-center pr-3">
              <div class="col-12 text-center">
                {{ GetAtach(CardItem[detailInModal]) }}
                <div class="text-center">
                  <i class="fas fa-square ml-2 text-info"></i>
                  <span style="font-size: 18px !important" v-if="$session.get('CustCode') == 868 && CardItem[detailInModal].spName != null && CardItem[detailInModal].spName != ''">
                    امتیاز وام مسکن شما [ <b class="text-warning">{{ CardItem[detailInModal].emtiazXas }}</b
                    >] می باشد
                  </span>
                  <span style="font-size: 18px !important" v-if="$session.get('CustCode') == 868 && CheckIsSaham(CardItem[detailInModal])">
                    امتیاز وام تعاونی شما [ <b class="text-warning">{{ CardItem[detailInModal].emtiazXas }}</b
                    >] می باشد
                  </span>
                </div>
              </div>
            </div>

            <!-- <div class="col-6 "></div>
                                <div class="col-1"></div>
                                <div class="col-10 border border-bottom mt-2"></div>
                                <div class="col-1"></div>
                                <div class="col-md-6 col-12 mt-1 text-right mt-2" style="font-size:15px !important"><i class="fas fa-square ml-2 text-warning"></i> امتیاز وام: <span class="text-light" style="font-size:15px !important"> {{$Comma3ragham(CardItem[detailInModal].mablaghMasdodBabateMoarefi)}}</span></div>
                                <div class="col-md-6 col-12 mt-1 text-right mt-2" style="font-size:15px !important"><i class="fas fa-square ml-2 text-warning"></i>امتیاز حساب:  <span class="text-light" style="font-size:15px !important"> {{$Comma3ragham(CardItem[detailInModal].mablaghMasdodBabateMoarefi)}}</span></div> -->
          </div>
          <div v-if="detailInModalSahebHesab != null" class="row p-3 rounded" style="background: #343a40">
            <div class="col-12 text-right">
              <h6 class="font-weight-bold text-right" style="font-size: 14px">
                <i class="fas fa-money-check ml-2" style="font-size: 14px"></i>
                {{ CardItem[detailInModalSahebHesab].desNoe }}
              </h6>
            </div>
            <!-- <div class="col-md-6 col-12 mt-1 text-right mt-2" style="font-size:15px !important"><i class="fas fa-square ml-2 text-success"></i> نوع حساب: <span class="text-dark" style="font-size:15px !important"> {{CardItem[detailInModal].desNoe}}</span></div> -->
            <div class="col-md-6 col-12 mt-1 text-right mt-2" style="font-size: 15px !important">
              <i class="fas fa-square ml-2 text-success"></i>شماره حساب:
              <span class="text-light" dir="rtl" style="font-size: 15px !important"> {{ CardItemTaahodatSahebHesab[detailInModalSahebHesab].vCode }}</span>
            </div>
            <div class="col-md-6 col-12 mt-1 text-right mt-2" style="font-size: 15px !important">
              <i class="fas fa-square ml-2 text-success"></i>مانده:
              <span class="text-light" dir="rtl" style="font-size: 15px !important"> {{ $Comma3ragham(CardItemTaahodatSahebHesab[detailInModalSahebHesab].mande) }}</span>
            </div>
            <div class="col-md-6 col-12 mt-1 text-right mt-2" style="font-size: 15px !important">
              <i class="fas fa-square ml-2 text-success"></i>تاریخ افتتاح حساب:
              <span class="text-light" dir="rtl" style="font-size: 15px !important"> {{ CardItemTaahodatSahebHesab[detailInModalSahebHesab].tarix }}</span>
            </div>
            <div class="col-md-6 col-12 mt-1 text-right mt-2" style="font-size: 15px !important">
              <i class="fas fa-square ml-2 text-success"></i>تاریخ شروع شارژ:
              <span class="text-light" dir="rtl" style="font-size: 15px !important"> {{ CardItemTaahodatSahebHesab[detailInModalSahebHesab].tarixShoroAghsat }}</span>
            </div>

            <div class="col-1 my-2"></div>
            <div class="col-10 border border-bottom my-2"></div>
            <div class="my-2"></div>
            <div class="col-12 text-right mt-2">
              <h6 class="font-weight-bold text-right" style="font-size: 14px"><i class="fas fa-ban ml-2" style="font-size: 14px"></i> مسدودی ها</h6>
            </div>
            <div class="col-md-6 col-12 mt-1 text-right mt-2" style="font-size: 15px !important">
              <i class="fas fa-square ml-2 text-warning"></i>مسدودی:
              <span class="text-light" style="font-size: 15px !important"> {{ $Comma3ragham(CardItemTaahodatSahebHesab[detailInModalSahebHesab].mablaghSood) }}</span>
            </div>
            <div class="col-md-6 col-12 mt-1 text-right mt-2" style="font-size: 15px !important">
              <i class="fas fa-square ml-2 text-warning"></i> مسدودي بابت دريافت تسهيلات:
              <span class="text-light" style="font-size: 15px !important"> {{ $Comma3ragham(CardItemTaahodatSahebHesab[detailInModalSahebHesab].mablaghMasdodBabateDarTashilat) }}</span>
            </div>
            <div class="col-md-6 col-12 mt-1 text-right mt-2" style="font-size: 15px !important">
              <i class="fas fa-square ml-2 text-warning"></i>مسدودي بابت معرفی:
              <span class="text-light" style="font-size: 15px !important"> {{ $Comma3ragham(CardItemTaahodatSahebHesab[detailInModalSahebHesab].mablaghMasdodBabateMoarefi) }}</span>
            </div>
            <!-- <div class="col-6 "></div>
                                <div class="col-1"></div>
                                <div class="col-10 border border-bottom mt-2"></div>
                                <div class="col-1"></div>
                                <div class="col-md-6 col-12 mt-1 text-right mt-2" style="font-size:15px !important"><i class="fas fa-square ml-2 text-warning"></i> امتیاز وام: <span class="text-light" style="font-size:15px !important"> {{$Comma3ragham(CardItem[detailInModal].mablaghMasdodBabateMoarefi)}}</span></div>
                                <div class="col-md-6 col-12 mt-1 text-right mt-2" style="font-size:15px !important"><i class="fas fa-square ml-2 text-warning"></i>امتیاز حساب:  <span class="text-light" style="font-size:15px !important"> {{$Comma3ragham(CardItem[detailInModal].mablaghMasdodBabateMoarefi)}}</span></div> -->
          </div>
        </div>
      </template>
    </modal-custom>
  </div>
</template>
<script>
import ModalCustom from "../Tools/ModalCustom.vue";
import Panel from "../Tools/NetPa/Panel.vue";
import Debtor from "./Debtor.vue";
import VueBootstrap4Table from "vue-bootstrap4-table";
import loading from "../Tools/NetPa/Loading.vue";
import html2pdf from "html2pdf.js";
import Num2persian from "num2persian";
export default {
  data() {
    return {
      logo: {},
      emza1: {},
      emza2: {},
      GridDataAtachVam: [],
      AtachVam: false,
      loadingRender: false,
      CardItem: null,
      CardItemTaahodatSahebHesab: 0,
      FilterCardItemTaahodatSahebHesab: null,
      DataAxiosRow: {
        ArryfildValue: "",
        Method: "Post",
        Action: "ListTaahodat",
        Token: this.$session.get("TokenNetPa"),
      },
      DataAxios_SahebHesab: {
        ArryfildValue: "",
        Method: "Post",
        Action: "ListTaahodat/TaahodatSahebHesab",
        Token: this.$session.get("TokenNetPa"),
      },
      taahodatId: 0,
      detailInModal: null,
      detailInModalSahebHesab: null,
      selectedBedehi: true,
      selectedAllBedehi: false,
      IsTaahodatSahebHesab: false,
      IsShowCard: true,
      groupBy: null,
      rows: [],
      columns: [
        {
          label: "id",
          name: "id",
          visibility: false,
        },
        {
          label: "نوع",
          name: "desNoe",
        },
        {
          label: "شماره",
          name: "vCode",
        },
        {
          label: "افتتاح حساب",
          name: "tarix",
        },
        {
          label: "شناسه واریز ",
          name: "shenaseVariz",
        },
        {
          label: "موجودی",
          name: "NewMande",
        },
        {
          label: "قابل برداشت",
          name: "NewghabelBardasht",
          visibility: this.$session.get("CustCode") == 868 ? false : true,
        },
        {
          label: "جزئیات",
          name: "Detail",
          visibility: true,
        },
        {
          label: "امتیاز شما",
          name: "Emtiaz",
          visibility: true,
        },
        {
          label: "عملیات ها",
          name: "id",
          slot_name: "action-slot",
          sort: false,
        },
      ],
      rows2: [],
      columns2: [
        {
          label: "id",
          name: "id",
          visibility: false,
        },
        {
          label: "نوع",
          name: "desNoe",
        },
        {
          label: "شماره",
          name: "vCode",
        },
        {
          label: "مشخصات",
          name: "nameFamily",
        },
        {
          label: "افتتاح حساب",
          name: "tarix",
        },
        {
          label: "شناسه واریز ",
          name: "shenaseVariz",
        },
        {
          label: "موجودی",
          name: "NewMande",
        },
        {
          label: "قابل برداشت",
          name: "NewghabelBardasht",
        },
        {
          label: "عملیات ها",
          name: "id",
          slot_name: "action-slot",
          sort: false,
        },
      ],
      config: {
        pagination: false,
        pagination_info: false,
        per_page_options: [10, 20, 30, 50, 100],
        show_refresh_button: false,
        show_reset_button: false,
        checkbox_rows: false,
        rows_selectable: true,
        card_title: "",
        card_mode: false,
        global_search: {
          placeholder: " جستجو",
          visibility: true,
          case_sensitive: false,
          showClearButton: true,
          searchOnPressEnter: false,
          searchDebounceRate: 1000,
        },
      },
      classes: {
        table: "table-bordered table-striped  ",
      },
      DataAxiosSaham: {},
    };
  },
  components: {
    Panel,
    ModalCustom,
    Debtor,
    VueBootstrap4Table,
    loading,
    html2pdf,
  },
  mounted() {
    this.GetItemCard(true);
    var a = document.getElementById("dropdownMenuButton");
    a.click();
    this.GetItemCardTaahodatSahebHesab();
    this.getSahamsettings();
  },
  methods: {
    GetSahebHesab(id, IsAll) {
      let info;
      let list = [];
      if (IsAll) {
        this.IsTaahodatSahebHesab = true;
        this.FilterCardItemTaahodatSahebHesab = this.CardItemTaahodatSahebHesab;
        for (let index = 0; index < this.FilterCardItemTaahodatSahebHesab.length; index++) {
          info = this.FilterCardItemTaahodatSahebHesab[index];
          info["NewMande"] = Number(this.FilterCardItemTaahodatSahebHesab[index].mande) + Number(this.FilterCardItemTaahodatSahebHesab[index].sumMabTaeedNaShode);
          info["NewghabelBardasht"] = Number(this.FilterCardItemTaahodatSahebHesab[index].ghabelBardasht) + Number(this.FilterCardItemTaahodatSahebHesab[index].sumMabTaeedNaShode);
          list.push(info);
        }
        this.rows2 = this.$FormatMablaghGrid(list);
      } else {
        this.IsTaahodatSahebHesab = true;
        this.FilterCardItemTaahodatSahebHesab = this.CardItemTaahodatSahebHesab.filter((x) => x.wwwtblAzaId == id);
        for (let index = 0; index < this.FilterCardItemTaahodatSahebHesab.length; index++) {
          info = this.FilterCardItemTaahodatSahebHesab[index];
          info["NewMande"] = Number(this.FilterCardItemTaahodatSahebHesab[index].mande) + Number(this.FilterCardItemTaahodatSahebHesab[index].sumMabTaeedNaShode);
          info["NewghabelBardasht"] = Number(this.FilterCardItemTaahodatSahebHesab[index].ghabelBardasht) + Number(this.FilterCardItemTaahodatSahebHesab[index].sumMabTaeedNaShode);
          list.push(info);
        }
        this.rows2 = this.$FormatMablaghGrid(list);
      }
    },
    ShowCard(status) {
      this.IsShowCard = status;
    },
    GetItemCard(IsAll) {
      let info;
      let list = [];
      const formData = new FormData();
      formData.append("wwwtblAzaId", this.$session.get("UserInfoNetPa").wwwtblAzaId);
      formData.append("wwwtblSarfaslTypeId", 2);
      this.DataAxiosRow.ArryfildValue = formData;
      this.$PostFormData(this.DataAxiosRow).then((data) => {
        if (IsAll) {
          this.CardItem = data.filter((x) => x.tblSarfaslTypeId != 6);
          this.selectedBedehi = false;
          this.selectedAllBedehi = true;

          for (let index = 0; index < data.length; index++) {
            info = data[index];
            info["NewMande"] = data[index].mande + data[index].sumMabTaeedNaShode;
            info["NewghabelBardasht"] = data[index].ghabelBardasht + data[index].sumMabTaeedNaShode;
            list.push(info);
          }
          this.rows = this.$FormatMablaghGrid(this.CardItem);
        } else {
          this.CardItem = data.filter((x) => x.mande > 0 && x.tblSarfaslTypeId != 6);
          this.selectedBedehi = true;
          this.selectedAllBedehi = false;

          for (let index = 0; index < data.length; index++) {
            info = data[index];
            if (info.mande > 0 && info.tblSarfaslTypeId != 6) {
              info["NewMande"] = data[index].mande + data[index].sumMabTaeedNaShode;
              info["NewghabelBardasht"] = data[index].ghabelBardasht + data[index].sumMabTaeedNaShode;
              list.push(info);
            }
          }
          this.rows = this.$FormatMablaghGrid(list.filter((x) => x.mande > 0));
        }
      });
    },
    GetItemCardTaahodatSahebHesab() {
      this.loadingRender = true;
      const formData = new FormData();
      formData.append("wwwtblAzaId", this.$session.get("UserInfoNetPa").wwwtblAzaId);
      formData.append("wwwtblSarfaslTypeId", 2);
      this.DataAxios_SahebHesab.ArryfildValue = formData;
      this.$PostFormData(this.DataAxios_SahebHesab)
        .then((data) => {
          this.CardItemTaahodatSahebHesab = data.filter((x) => x.tblSarfaslTypeId != 6);
          var result = this.CardItemTaahodatSahebHesab.reduce((unique, o) => {
            if (!unique.some((obj) => obj.wwwtblAzaId === o.wwwtblAzaId && obj.value === o.value)) {
              unique.push(o);
            }
            return unique;
          }, []);
          this.groupBy = result;
        })
        .finally(() => {
          if (this.$session.get("UserFromAccount")) {
            if (this.$session.get("UserFromAccount")[1] == true) {
              if (this.$session.get("UserFromAccount")[0] != this.$session.get("UserInfoNetPa").wwwtblAzaId) {
                document.getElementById("Logo-tab").click();
                document.getElementById(this.$session.get("UserFromAccount")[0]).click();
                this.$session.remove("UserFromAccount");
              } else {
                this.$session.remove("UserFromAccount");
              }
            }
          }
          this.loadingRender = false;
        });
    },
    Deposit(Taahodat) {
      // console.log("🤦🏻‍♂️ ~ file: Accounts.vue:925 ~ Taahodat:", Taahodat.tblSarfaslTypeId)
      this.$router.push({
        name: "Deposit",
        params: {
          TaahodatItem: Taahodat,
          wwwtblAzaIdAccount: Taahodat.wwwtblAzaId,
          IsTashilat: false,
        },
      });
    },
    Payment() {
      this.$router.push({
        name: "Debtor",
      });
    },
    debtor(row) {
      var GhebelBardasht = Number(row.ghabelBardasht.replace(/,/g, "").replace(/\./g, "")) + Number(row.sumMabTaeedNaShode.replace(/,/g, "").replace(/\./g, ""));
      this.$router.push({ name: "Debtor", params: { TaahodatId: row.id, GhebelBardasht: GhebelBardasht } });
    },
    OpenDetail(index) {
      this.detailInModalSahebHesab = null;
      this.detailInModal = index;
    },
    OpenDetailSahebanHesab(index) {
      this.detailInModal = null;
      this.detailInModalSahebHesab = index;
    },
    GetAtach(row) {
      if (row.spName != null) {
        let Params = "";
        let QParams = row.spName.split("@");

        for (let index = 1; index < QParams.length; index++) {
          Params = Params + "@" + QParams[index];
        }
        if (Params.match("@ShmoareOzv = 0") != null) {
          Params = Params.replaceAll("@ShmoareOzv = 0", "@ShmoareOzv =' " + this.$session.get("UserInfoNetPa").shomareOzv.trim() + "'");
        }
        if (Params.match("@ShmoareOzv= 0") != null) {
          Params = Params.replaceAll("@ShmoareOzv= 0", "@ShmoareOzv =' " + this.$session.get("UserInfoNetPa").shomareOzv.trim() + "'");
        }
        if (Params.match("@ShmoareOzv=0") != null) {
          Params = Params.replaceAll("@ShmoareOzv=0", "@ShmoareOzv =' " + this.$session.get("UserInfoNetPa").shomareOzv.trim() + "'");
        }
        var DataAxios = {
          ArryfildValue: "",
          Method: "Post",
          Action: "InsNewVam/AatachVam",
          Token: this.$session.get("TokenNetPa"),
        };
        const formData = new FormData();
        formData.append("Params", Params);
        formData.append("Query", QParams[0]);
        DataAxios.ArryfildValue = formData;
        this.$PostFormData(DataAxios).then((data) => {
          let a = JSON.parse(data);
          this.GridDataAtachVam = a;
        });
      }
    },
    GetSumEmtiaz() {
      let SumEmtiaz = 0;
      this.GridDataAtachVam.forEach((el) => {
        SumEmtiaz += el.Emtiaz;
      });
      return SumEmtiaz;
    },
    getSahamsettings() {
      var DataAxios_GetSaham = {
        ArryfildValue: "",
        Method: "Post",
        Action: "TanzimatNoe/GetSahamSettings",
        Token: this.$session.get("TokenNetPa"),
      };
      const formData = new FormData();
      DataAxios_GetSaham.ArryfildValue = formData;
      this.$PostFormData(DataAxios_GetSaham).then((data) => {
        // console.log('😎 ~ this.$PostFormData ~ data:', data)
        this.DataAxiosSaham = data.data;
        this.logo = data.logo;
        this.emza1 = data.emza1;
        this.emza2 = data.emza2;
      });
    },
    CheckIsSaham(row) {
      // console.log(row.wwwtblNoeId);
      // console.log(this.DataAxiosSaham.wwwtblNoeId);
      return this.DataAxiosSaham.wwwtblNoeId == row.wwwtblNoeId;
    },
    ShowBargeSaham(item) {
      var html = ``;
      var Taahoadat = item;
      // this.$router.push({ name: 'PrintBargeSaham', params: { Data: this.DataAxiosSaham, Taahoadat: item, Image: { logo: this.logo, emza1: this.emza1, emza2: this.emza2 } } })
      if (this.$session.get("CustCode") == 574) {
        html = `
        <div class="container Border-Rouded Border  p-1 px-2 " style="height:14.4cm !important;width:20.5cm !important; color:#000; margin-top:.2cm">
          <div class="row " style="height:14cm !important; width:20.2cm !important" >
          <div class="m-1 py-2 col-12">
            <div class="row">
              <div class="col-4"></div>
              <div class="col-4 text-center">تعاونوا علی البر والتقوی</div>
              <div class="col-4">
                <span class="font-16px">شماره سریال : </span><span>${this.DataAxiosSaham.serialNumber}</span>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-md-8 col-12 font-weight-bold text-right pr-5" style="font-size: 15px !important">${this.$session.get("UserInfoNetPa").customerName}</div>
              <div class="col-md-4 col-12 font-16px">تاریخ صدور : ${this.$GetJalaliDate()}</div>
            </div>
            <div class="text-center " style="margin-bottom:1cm;margin-top:1cm;"> << برگه سهام  >> </div>
            <hr/>
            <div class="row mt-2">
              <div class="col-md-2 col-12">
                <span class="font-16px">شماره ثبت : </span><span class="font-16px">${this.DataAxiosSaham.shomareSabt}</span>
              </div>
              <div class="col-md-3 col-12">
                <span class="font-16px">شناسه ملی :</span><span class="font-16px">${this.DataAxiosSaham.shenaseMeli}</span>
              </div>
              <div class="col-md-3 text-right col-12">
                <span class="mr-5 font-16px"> تعداد سهام</span>
                <span class="font-weight-bold"> ${Math.floor(Taahoadat.mande.replace(/,/g, "").replace(/\./g, "") / this.DataAxiosSaham.arzeshHarSahm)} سهم</span>
                
              </div>
              <div class="col-md-4 text-right col-12">
                <span class="font-16px">مبلغ اسمی هر سهم :</span><span class="font-16px">${this.$Comma3ragham(this.DataAxiosSaham.arzeshHarSahm)}</span> ریال
              </div>
            </div>
            <div class="text-center mt-2"> مشخصات صاحب برگه سهام </div>
            <div class="row mt-3">
              <div class="col-md-6 mt-2 col-12 text-center">
                <span class="font-16px"> نام خانوادگی و نام :</span><span class="font-weight-bold font-16px">${this.$session.get("UserInfoNetPa").ozvFamily} ${
          this.$session.get("UserInfoNetPa").ozvName
        } </span>
              </div>
              <div class="col-md-6 mt-2 col-12 text-center">
                <span class="font-16px"> نام پدر :</span><span class="font-weight-bold font-16px"> ${
                  this.$session.get("UserInfoNetPa").pedar ? this.$session.get("UserInfoNetPa").pedar : "______"
                } </span>
              </div>
              <div class="col-md-6 mt-2 col-12 text-center">
                <span class="font-16px"> کد ملی :</span><span class="font-weight-bold font-16px"> ${
                  this.$session.get("UserInfoNetPa").codeMeli ? this.$session.get("UserInfoNetPa").codeMeli : "______"
                } </span>
              </div>
              <div class="col-md-6 mt-2 col-12 text-center">
                <span class="font-16px"> شماره عضویت سهامدار:</span><span class="font-weight-bold font-16px" dir="rtl"> ${this.$session.get("UserInfoNetPa").shomareOzv} </span>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-md-2 col-12 text-left">
                <div class="font-10px"> هیئت مدیره</div>
                <div class="font-16px">${this.DataAxiosSaham.pishNevis1}</div>
              </div>
              <div class="col-md-2 col-12 text-right pr-0 pt-0">
                <img style="height: 10vh;max-width:3.7cm !important;" src="data:image/png;base64, ${this.emza1.binary}" />
              </div>
              <div class="col-md-2 col-12 text-left">
                <div class="font-10px">مدیر عامل</div>
                <div class="font-16px">${this.DataAxiosSaham.pishNevis2}</div>
              </div>
              <div class="col-md-2 col-12 text-right pr-0 pt-0">
                <img style="height: 10vh;max-width:3.7cm !important;" src="data:image/png;base64, ${this.emza2.binary}" />
                
              </div>
              <div class="col-md-2 col-12 text-left"><div class="font-10px">مهر شرکت</div></div>
              <div class="col-md-2 col-12 text-right pr-0 pt-0">
                <img style="height: 10vh;max-width:3.7cm !important;" src="data:image/png;base64, ${this.logo.binary}" />
              </div>
            </div>
            <div class="px-5 mt-4 text-center" style="font-size:11px !important;">
                نقل و انتقال سهام صرفا در محل شرکت تعاونی واقع در آدرس تبریز، کوچه شفائیه ف بلوار شهدا ، کد پستی 5134916579
            </div>
            <div class="px-5 text-center mt-1" style="font-size:11px !important;">
                تلفن 35291357 و فاکس 35259200 امکان پذیز می باشد
            </div>
            <div class="px-5 mt-1 text-center" style="font-size:11px !important;">
                برگه های سهام صادر شده قبلی فاقد اعتبار می باشد .
            </div>
            <div class="mt-3 text-center ml-3" style="font-size:11px !important;">
                برگه مخصوص سهامدار 
            </div>
          </div>
          </div>
        </div>
        `;
      }
      if (this.$session.get("CustCode") == 868 || this.$session.get("CustCode") == 886) {
        html = `
              <div class="container text-center p-1 px-2" style="height:14.4cm !important;width:20.5cm !important; color:#000; margin-top:.2cm">
                <div class="row Border print" style="height:14cm !important; width:20.2cm !important;margin-right:0.05cm;">
                  <div class=" m-1 py-2 w-100 col-12">
                    <div class="row">
                      <div class="col-md-3 col-12"></div>
                      <div class="col-md-6 col-12">بسمه تعالی</div>
                      <div class="col-md-3 col-12"></div>
                    </div>
                    <div class="row">
                      <div class="col-md-3 col-12">
                        <div class="row">
                          <div class="col-md-6 col-12 text-left mt-2"><span class="">شماره و تاریخ ثبت</span></div>
                          <div class="col-md-6 col-12 text-center pr-0">
                            <div class="border-bottom">${this.DataAxiosSaham.shomareSabt}</div>
                            <div class="mt-2">${this.DataAxiosSaham.tarixSabt}</div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6 col-12">
                        <div class="font-weight-bold" style="font-size: 15px" >شرکت تعاونی اعتبار کارکنان وزارت امور اقتصادی و دارایی</div>
                        <div class="font-weight-bold mt-2" style="font-size: 15px">برگه سهــام</div>
                      </div>
                      <div class="col-md-3 col-12 text-right pr-0">
                        <img style="max-width:4cm;" src="data:image/png;base64,${this.logo.binary} " />
                      </div>
                    </div>
                    <!-- <div class="row mt-5">
                                <div class="col-12 text-right"><span class="mr-5 font-weight-bold" style="font-size:15px;">برگه سهــام</span></div>
                            </div> -->
                    <div class="row mt-3">
                      <div class="col-md-4 col-12 text-center">
                        <span class="font-16px"> نام دارنده سهــم :</span><span class="font-weight-bold font-16px"> ${this.$session.get("UserInfoNetPa").ozvName} ${
          this.$session.get("UserInfoNetPa").ozvFamily
        } </span>
                      </div>
                      <div class="col-md-4 col-12 text-center">
                        <span class="font-16px"> نام پدر :</span><span class="font-weight-bold font-16px"> ${
                          this.$session.get("UserInfoNetPa").pedar ? this.$session.get("UserInfoNetPa").pedar : "______"
                        } </span>
                      </div>
                      <div class="col-md-4 col-12 text-center">
                        <span class="font-16px"> کد ملی :</span><span class="font-weight-bold font-16px"> ${
                          this.$session.get("UserInfoNetPa").codeMeli ? this.$session.get("UserInfoNetPa").codeMeli : "______"
                        } </span>
                      </div>
                    </div>
                    <div class="row mt-3">
                      <div class="col-md-4 col-12 text-center">
                        <span class="font-16px"> شماره شناسنامه:</span><span class="font-weight-bold font-16px"> ${
                          this.$session.get("UserInfoNetPa").shenasname == null ? "______" : this.$session.get("UserInfoNetPa").shenasname
                        } </span>
                      </div>
                      <div class="col-md-4 col-12 text-center">
                        <span class="font-16px"> شماره عضویت سهامدار:</span><span class="font-weight-bold font-16px" dir="rtl"> ${this.$session.get("UserInfoNetPa").shomareOzv} </span>
                      </div>
                      <div class="col-md-4 col-12 text-center"></div>
                    </div>
                    <div class="row mt-3">
                      <div class="col-md-4 col-12 text-center">
                        <span class="font-16px mr-5"> دارای تعداد </span>
                        <span class="font-weight-bold font-16px"> ${Math.floor(Taahoadat.mande.replace(/,/g, "").replace(/\./g, "") / this.DataAxiosSaham.arzeshHarSahm)} </span>
                        <span class="font-16px"> سهــــم </span>
                      </div>
                      <div class="col-md-4 col-12 text-center">
                        <span class="font-16px"> به ارزش اسمی هر سهـــم </span>
                        <span class="font-weight-bold font-16px"> ${this.$Comma3ragham(this.DataAxiosSaham.arzeshHarSahm)} </span>
                        <span class="font-16px"> ریال </span>
                      </div>
                      <div class="col-md-4 col-12 text-center">
                        <span class="font-16px"> تا تاریخ </span>
                        <span class="font-weight-bold font-16px"> ${this.$GetJalaliDateTime()} </span>
                      </div>
                    </div>
                    <div class="row mt-3">
                      <div class="col-md-4 col-12 text-center"><span class="font-16px"> محل خدمت :</span><span class="font-weight-bold font-16px"> وزارت امور اقتصادی ودارایی </span></div>
                      <div class="col-md-8 col-12 text-center"></div>
                    </div>
                    <div class="row mt-4">
                      <!-- <div class="col-md-2 col-12 text-center"></div> -->
                      <div class="col-md-12 col-12 text-center">
                        <div class="row">
                          <div class="col-md-3 col-12 text-left">
                            <div class="font-16px">رئیس هیئت مدیره</div>
                            <div class="font-16px">${this.DataAxiosSaham.pishNevis1}</div>
                          </div>
                          <div class="col-md-3 col-12 text-right pr-0 pt-0">
                            <img style="height: 10vh" src="data:image/png;base64,${this.emza1.binary}" />
                          </div>
                          <div class="col-md-3 col-12 text-left">
                            <div class="font-16px">مدیر عامل</div>
                            <div class="font-16px">${this.DataAxiosSaham.pishNevis2}</div>
                          </div>
                          <div class="col-md-3 col-12 text-right pr-0 pt-0">
                            <img style="height: 10vh" src="data:image/png;base64,${this.emza2.binary}" />
                          </div>
                        </div>
                      </div>
                      <!-- <div class="col-md-2 col-12 text-center"></div> -->
                    </div>
                  </div>
                </div>
              </div>
        `;
      }
      if (this.$session.get("CustCode") == 932) {
        html = `
              <div class="container text-center p-1 px-2" style="height:14.4cm !important;width:20.5cm !important; color:#000; margin-top:.2cm">
                <div class="row print" style="height:14cm !important; width:20.2cm !important;margin-right:0.05cm;">
                  <div class="col-12 Border pl-3 print" >
                    <div class=" m-1 py-2 w-100">
                      <div class="row mt-3">
                        <div class="col-md-9 col-12">
                          <div class="row">
                            <div class="col-5">
                              <div class="row">
                                <div class="col-md-6 col-12 text-left mt-2"><span class="">شماره سهام دار</span></div>
                                <div class="col-md-6 col-12 text-right pr-0">
                                  <div class="mt-2">${this.$session.get("UserInfoNetPa").perNo == null ? " - - - " : this.$session.get("UserInfoNetPa").perNo}</div>
                                </div>
                              </div>
                            </div>
                            <div class="col-7 text-center">
                              <div class="font-weight-bold" style="font-size: 15px">گواهینامه سهام</div>
                              <div class="font-weight-bold mt-1" style="font-size: 15px">شرکت تعاونی اعتبار کارکنان سازمان تامین اجتماعی</div>
                              <div class="font-weight-bold mt-1" style="font-size: 15px">( سهامی خاص )</div>
                            </div>
                          </div>
                          <div class="row mt-5">
                            <div class="col-12 mt-4">
                              <div class="text-right mr-5">
                                <span class="font-16px"> مبلغ اسمی هر سهم : </span>
                                <span class="font-weight-bold font-16px"> ${this.$Comma3ragham(this.DataAxiosSaham.arzeshHarSahm)} </span>
                                <span class="font-16px"> ریال </span>
                              </div>
                              <div class="text-right mt-3 mr-5">
                                <span class="font-16px"> نام دارنده سهــم :</span><span class="font-weight-bold font-16px"> ${this.$session.get("UserInfoNetPa").ozvName} ${
          this.$session.get("UserInfoNetPa").ozvFamily
        } </span>
                              </div>
                            </div>
                          </div>
                          <div class="row text-right pr-5">
                            <div class="col-12 mt-3">
                              <span class="font-16px"> شماره شناسنامه:</span><span class="d-inline font-weight-bold font-16px"> ${
                                this.$session.get("UserInfoNetPa").shenasname
                              } </span> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                              <span class="font-16px"> محل تولد :</span><span class="font-weight-bold font-16px" dir="rtl"> ${
                                this.$session.get("UserInfoNetPa").mahalSodor
                              } </span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <span class="font-16px"> نام پدر :</span>
                              <span class="font-weight-bold font-16px"> ${
                                this.$session.get("UserInfoNetPa").pedar ? this.$session.get("UserInfoNetPa").pedar : "______"
                              } </span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 
                            </div>
                            <div class="col-12 mt-3">
                              <span class="font-16px"> کد ملی :</span><span class="font-weight-bold font-16px" dir="rtl">${this.$session.get("UserInfoNetPa").codeMeli} </span>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-3 col-12 text-center pr-0">
                          <img style="max-width:4cm;" src="data:image/png;base64,${this.logo.binary} " />
                          <div class="text-center">
                            <div class="mt-2">شماره ثبت : ${this.DataAxiosSaham.shomareSabt}</div>
                            <div class="">شناسه ملی : ${this.DataAxiosSaham.shenaseMeli}</div>
                            <div class="">تاریخ ثبت شرکت: ${this.DataAxiosSaham.tarixSabt}</div>
                          </div>
                        </div>
                      </div>

                      <div class="row mt-5">
                        <div class="col-12 text-right text-center font-weight-bold" style="font-size: 15px !important">
                          <span>این ورقه نماینده یک سهم </span>
                          <span>${this.Mab2persian()}</span>
                          <span> می باشد </span>
                        </div>
                        <div class="col-12 text-right text-center" style="font-size: 12px !important">(دارنده سهم تابع قانون تجارت و کلیه مقررات اساسنامه شرکت است)</div>
                      </div>

                      <div class="row mt-3">
                        <div class="col-md-12 col-12 text-center"></div>
                      </div>

                      <div class="row mt-4">
                        <!-- <div class="col-md-2 col-12 text-center"></div> -->
                        <div class="col-md-12 col-12 text-center">
                          <div class="row">
                            <div class="col-md-3 col-12 text-left">
                              <div class="font-16px">رئیس هیئت مدیره</div>
                              <div class="font-16px">${this.DataAxiosSaham.pishNevis1}</div>
                            </div>
                            <div class="col-md-3 col-12 text-right pr-0 pt-0">
                              <img style="height: 10vh" src="data:image/png;base64, ${this.emza1.binary}" />
                            </div>
                            <div class="col-md-3 col-12 text-left">
                              <div class="font-16px">مدیر عامل</div>
                              <div class="font-16px">${this.DataAxiosSaham.pishNevis2}</div>
                            </div>
                            <div class="col-md-3 col-12 text-right pr-0 pt-0">
                              <img style="height: 10vh" src="data:image/png;base64,${this.emza2.binary}" />
                            </div>
                          </div>
                        </div>
                        <!-- <div class="col-md-2 col-12 text-center"></div> -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
        `;
      }
      if (this.$session.get("CustCode") == 352) {
        html = `
              <div class="container text-center p-1 px-2" style="height:14.4cm !important;width:20.5cm !important; color:#000; margin-top:.2cm">
                <div class="row print" style="height:14cm !important; width:20.2cm !important;margin-right:0.05cm;">
                  <div class="col-12 Border pl-3 print" >
                    <div class=" m-1 py-2 w-100">
                      <div class="row mt-3">
                        <div class="col-md-9 col-12">
                          <div class="row">
                            <div class="col-5">
                              <div class="row">
                                <div class="col-md-6 col-12 text-left mt-2"><span class="">شماره سهام دار</span></div>
                                <div class="col-md-6 col-12 text-right pr-0">
                                  <div class="mt-2">${this.$session.get("UserInfoNetPa").perNo == null ? " - - - " : this.$session.get("UserInfoNetPa").perNo}</div>
                                </div>
                              </div>
                            </div>
                            <div class="col-7 text-center">
                              <div class="font-weight-bold" style="font-size: 13px">گواهینامه سهام</div>
                              <div class="font-weight-bold mt-1" style="font-size: 13px">تعاوني اعتبار كاركنان سازمان آموزش فني حرفه اي كشور</div>
     
                            </div>
                          </div>
                          <div class="row mt-5">
                            <div class="col-12 mt-4">
                              <div class="text-right mr-5">
                                <span class="font-16px"> مبلغ اسمی هر سهم : </span>
                                <span class="font-weight-bold font-16px"> ${this.$Comma3ragham(this.DataAxiosSaham.arzeshHarSahm)} </span>
                                <span class="font-16px"> ریال </span>
                              </div>
                              <div class="text-right mt-3 mr-5">
                                <span class="font-16px"> نام دارنده سهــم :</span><span class="font-weight-bold font-16px"> ${this.$session.get("UserInfoNetPa").ozvName} ${
          this.$session.get("UserInfoNetPa").ozvFamily
        } </span>
                              </div>
                            </div>
                          </div>
                          <div class="row text-right pr-5">
                            <div class="col-12 mt-3">
                              <span class="font-16px"> شماره شناسنامه:</span><span class="d-inline font-weight-bold font-16px"> ${
                                this.$session.get("UserInfoNetPa").shenasname
                              } </span> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                              <span class="font-16px"> محل تولد :</span><span class="font-weight-bold font-16px" dir="rtl"> ${
                                this.$session.get("UserInfoNetPa").mahalSodor
                              } </span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <span class="font-16px"> نام پدر :</span>
                              <span class="font-weight-bold font-16px"> ${
                                this.$session.get("UserInfoNetPa").pedar ? this.$session.get("UserInfoNetPa").pedar : "______"
                              } </span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 
                            </div>
                            <div class="col-12 mt-3">
                              <span class="font-16px"> کد ملی :</span><span class="font-weight-bold font-16px" dir="rtl">${
                                this.$session.get("UserInfoNetPa").codeMeli
                              } </span></span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                              <span class="mr-5 font-16px"> تعداد سهام</span><span class="font-weight-bold"> ${Math.floor(
                                Taahoadat.mande.replace(/,/g, "").replace(/\./g, "") / this.DataAxiosSaham.arzeshHarSahm
                              )} سهم</span>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-3 col-12 text-center pr-0">
                          <img style="max-width:4cm;" src="data:image/png;base64,${this.logo.binary} " />
                          <div class="text-center">
                            <div class="mt-2">شماره ثبت : ${this.DataAxiosSaham.shomareSabt}</div>
                            <div class="">شناسه ملی : ${this.DataAxiosSaham.shenaseMeli}</div>
                            <div class="">تاریخ ثبت شرکت: ${this.DataAxiosSaham.tarixSabt}</div>
                          </div>
                        </div>
                      </div>

                      <div class="row mt-5">
                        <div class="col-12 text-right text-center" style="font-size: 12px !important">(دارنده سهم تابع قانون تجارت و کلیه مقررات اساسنامه شرکت است)</div>
                      </div>

                      <div class="row mt-3">
                        <div class="col-md-12 col-12 text-center"></div>
                      </div>

                      <div class="row mt-4">
                        <!-- <div class="col-md-2 col-12 text-center"></div> -->
                        <div class="col-md-12 col-12 text-center">
                          <div class="row">
                            <div class="col-md-6 col-12 text-center">
                              <div class="font-16px">رئیس هیئت مدیره</div>
                              <div class="font-16px">${this.DataAxiosSaham.pishNevis1}</div>
                              <img style="height: 10vh;margin-top:-35px;" src="data:image/png;base64, ${this.emza1.binary}" />
                            </div>
                            <div class="col-md-6 col-12 text-center">
                              <div class="font-16px">مدیر عامل</div>
                              <div class="font-16px">${this.DataAxiosSaham.pishNevis2}</div>
                              <img style="height: 10vh;margin-top:-40px;" src="data:image/png;base64,${this.emza2.binary}" />
                            </div>
                          </div>
                        </div>
                        <!-- <div class="col-md-2 col-12 text-center"></div> -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
        `;
      }
      if (this.$session.get("CustCode") == 8002 || this.$session.get("CustCode") == 850) {
        html = `
              <div class="container text-center p-1 px-2" style="height:14.4cm !important;width:20.5cm !important; color:#000; margin-top:.2cm">
                <div class="row print" style="height:14cm !important; width:20.2cm !important;margin-right:0.05cm;">
                  <div class="col-12 Border pl-3 print" >
                    <div class=" m-1 py-2 w-100">
                      <div class="row mt-3">
                        <div class="col-md-9 col-12">
                          <div class="row">
                            <div class="col-5">
                              <div class="row">
                                <div class="col-md-6 col-12 text-left mt-2"><span class="">شماره سهام دار</span></div>
                                <div class="col-md-6 col-12 text-right pr-0">
                                  <div class="mt-2">${this.$session.get("UserInfoNetPa").perNo == null ? " - - - " : this.$session.get("UserInfoNetPa").perNo}</div>
                                </div>
                              </div>
                            </div>
                            <div class="col-7 text-center">
                              <div class="font-weight-bold" style="font-size: 13px">گواهینامه سهام</div>
                              <div class="font-weight-bold mt-1" style="font-size: 13px">تعاونی اعتبار کارکنان دانشگاه علوم پزشکی [تربت حیدریه]</div>
     
                            </div>
                          </div>
                          <div class="row mt-5">
                            <div class="col-12 mt-4">
                              <div class="text-right mr-5">
                                <span class="font-16px"> مبلغ اسمی هر سهم : </span>
                                <span class="font-weight-bold font-16px"> ${this.$Comma3ragham(this.DataAxiosSaham.arzeshHarSahm)} </span>
                                <span class="font-16px"> ریال </span>
                              </div>
                              <div class="text-right mt-3 mr-5">
                                <span class="font-16px"> نام دارنده سهــم :</span><span class="font-weight-bold font-16px"> ${this.$session.get("UserInfoNetPa").ozvName} ${
          this.$session.get("UserInfoNetPa").ozvFamily
        } </span>
                              </div>
                            </div>
                          </div>
                          <div class="row text-right pr-5">
                            <div class="col-12 mt-3">
                              <span class="font-16px"> شماره شناسنامه:</span><span class="d-inline font-weight-bold font-16px"> ${
                                this.$session.get("UserInfoNetPa").shenasname
                              } </span> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                              <span class="font-16px"> محل تولد :</span><span class="font-weight-bold font-16px" dir="rtl"> ${
                                this.$session.get("UserInfoNetPa").mahalSodor
                              } </span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <span class="font-16px"> نام پدر :</span>
                              <span class="font-weight-bold font-16px"> ${
                                this.$session.get("UserInfoNetPa").pedar ? this.$session.get("UserInfoNetPa").pedar : "______"
                              } </span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 
                            </div>
                            <div class="col-12 mt-3">
                              <span class="font-16px"> کد ملی :</span><span class="font-weight-bold font-16px" dir="rtl">${
                                this.$session.get("UserInfoNetPa").codeMeli
                              } </span></span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                              <span class="mr-5 font-16px"> تعداد سهام</span><span class="font-weight-bold"> ${Math.floor(
                                Taahoadat.mande.replace(/,/g, "").replace(/\./g, "") / this.DataAxiosSaham.arzeshHarSahm
                              )} سهم</span>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-3 col-12 text-center pr-0">
                          <img style="max-width:4cm;" src="data:image/png;base64,${this.logo.binary} " />
                          <div class="text-center">
                            <div class="mt-2">شماره ثبت : ${this.DataAxiosSaham.shomareSabt}</div>
                            <div class="">شناسه ملی : ${this.DataAxiosSaham.shenaseMeli}</div>
                            <div class="">تاریخ ثبت شرکت: ${this.DataAxiosSaham.tarixSabt}</div>
                          </div>
                        </div>
                      </div>

                      <div class="row mt-5">
                        <div class="col-12 text-right text-center" style="font-size: 12px !important">(دارنده سهم تابع قانون تجارت و کلیه مقررات اساسنامه شرکت است)</div>
                      </div>

                      <div class="row mt-3">
                        <div class="col-md-12 col-12 text-center"></div>
                      </div>

                      <div class="row mt-4">
                        <!-- <div class="col-md-2 col-12 text-center"></div> -->
                        <div class="col-md-12 col-12 text-center">
                          <div class="row">
                            <div class="col-md-6 col-12 text-center">
                              <div class="font-16px">رئیس هیئت مدیره</div>
                              <div class="font-16px">${this.DataAxiosSaham.pishNevis1}</div>
                              <img style="height: 10vh;margin-top:-35px;" src="data:image/png;base64, ${this.emza1.binary}" />
                            </div>
                            <div class="col-md-6 col-12 text-center">
                              <div class="font-16px">مدیر عامل</div>
                              <div class="font-16px">${this.DataAxiosSaham.pishNevis2}</div>
                              <img style="height: 10vh;margin-top:-40px;" src="data:image/png;base64,${this.emza2.binary}" />
                            </div>
                          </div>
                        </div>
                        <!-- <div class="col-md-2 col-12 text-center"></div> -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
        `;
      }
      // console.log(html);
      var htmlObject = document.createElement("div");
      htmlObject.innerHTML = html;
      html2pdf(htmlObject, {
        jsPDF: { format: "a5", orientation: "landscape" },
      });
    },
    CalcEmtiazXasForTable(EmtizatPerson) {
      let sum = 0;
      EmtizatPerson.forEach((el) => {
        if (el.Base != null) {
          sum += el.Emtiaz;
        }
      });
      return sum;
    },
    Mab2persian() {
      var Mab = this.DataAxiosSaham.arzeshHarSahm + "";
      Mab = this.$b_ToPersianNumber(Mab);
      // Mab=Mab/10
      return Num2persian(Mab) + " " + this.$cookies.get("VahedPool") + "ی";
    },
    openGeneratorQR(taahodat) {
      this.$router.push({ name: "GeneratorLinkPay", params: { Taahodat: taahodat } });
    },
  },
};
</script>
<style scoped>
.fl {
  float: left !important;
}
.bg-gray {
  background: #cecece !important;
}
.border-line {
  border-right: 1px solid #bdbdbd;
  text-align: center;
}

.costom-card {
  padding: 20px 40px 20px 20px;
  border-radius: 15px;
  /* box-shadow: 0px 4px 8px 0px #435ebe; */

  margin-top: 50px;
  margin-bottom: 50px;
}

.costom-card-sahebanhesab {
  padding: 20px 40px 20px 20px;
  border-radius: 15px;
  box-shadow: 0px 4px 8px 0px #95f1b4;

  margin-top: 50px;
  margin-bottom: 50px;
}

@media all and (max-width: 980px) {
  .custom-class {
    width: 100%;
    display: block;
  }
}

.btn-secondary:hover {
  outline: none !important;
  border: solid 1px gray !important;
}
</style>
<style>
@media print {
  .no-print {
    display: none;
  }
}

.Border {
  /* border: 3px solid rgb(0, 0, 0); */
  border: 9px double rgb(53, 120, 223);
}
.Border-Rouded {
  border: 3px solid rgb(0, 0, 0);
  border-radius: 8px;
}
.font-16px {
  font-size: 12px !important;
}
</style>
